export default __webpack_public_path__ + "static/media/Black Flat.b084df83.PNG";